import React from 'react';

import { Link, TableRow, TableCell } from '@gogame/components';

import { Status } from '.';

const SpendAdjustmentRow = ({
  adjustment: {
    id,
    dateFrom,
    affiliateName,
    status: { name: statusName, id: statusNameId },
  },
  onOpenSpendAdjustment,
}) => {
  const handleOpenSpendAdjustmentDetails = (_) => {
    onOpenSpendAdjustment(_, { id });
  };

  return (
    <TableRow key={`spendAdjustment_${id}`}>
      <TableCell>{id}</TableCell>
      <TableCell>
        <Link onClick={handleOpenSpendAdjustmentDetails}>
          {`${new Date(dateFrom).toLocaleString('en-us', {
            month: 'short',
          })} ${new Date(dateFrom).getFullYear()}/${affiliateName}`}
        </Link>
      </TableCell>
      <TableCell>
        <Status id={statusNameId}>{statusName}</Status>
      </TableCell>
    </TableRow>
  );
};

export default SpendAdjustmentRow;
